import * as React from "react";
import { ErrorStatus, Wrapper } from "./ErrorPageStyled";
import KudosContext from "src/context";

export class ErrorPageComponent extends React.Component<
  {},
  { counterStatus: number }
> {
  public static contextType = KudosContext;
  public context: React.ContextType<typeof KudosContext>;

  public readonly state = {
    counterStatus: 0,
  };

  public render() {
    return (
      <Wrapper>
        <ErrorStatus>{this.state.counterStatus}</ErrorStatus>
        {this.context!.errorMessage.message
          ? this.context!.errorMessage.message
          : "Something went wrong"}
      </Wrapper>
    );
  }

  private interval = setInterval(() => {
    this.setState({ counterStatus: this.state.counterStatus + 1 });
    const targetNumber = this.context!.errorMessage.status
      ? this.context!.errorMessage.status
      : 404;
    if (this.state.counterStatus === targetNumber) {
      clearInterval(this.interval);
    }
  }, 5);
}
